import { useRef } from 'react';
import { Box, Tooltip } from '@mui/material';
import { FlatOption } from 'pages/AuditLogs/types';
import { useRevealEllipsisInTooltip } from 'services/hooks';
import { textWithEllipsisStyle } from 'utilities';

const GroupHeaderContent = ({ option, onClick }: { option: FlatOption; onClick: () => void }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { tooltipRef, width } = useRevealEllipsisInTooltip();
  const containerWidth = containerRef.current?.offsetWidth || 0;
  const shouldShowTooltip = width > containerWidth;

  return (
    <Box
      ref={containerRef}
      sx={{
        fontWeight: 600,
        padding: '8px 16px',
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: '#f5f5f5',
        },
      }}
      onClick={onClick}>
      <Tooltip title={shouldShowTooltip ? option.label : ''} placement="top">
        <Box
          ref={tooltipRef}
          sx={{
            ...textWithEllipsisStyle,
            width: '100%',
          }}>
          {option.label}
        </Box>
      </Tooltip>
    </Box>
  );
};

export default GroupHeaderContent;
